import { GAME_CONFIG, type GameConfig } from "../config/gameConfig.ts";

const BASIS_POINTS = 10_000n;

export type CommunityMembershipSnapshot = {
  readonly channel: boolean;
  readonly chat: boolean;
};

export type CommunityBonusQuote = {
  readonly eligible: boolean;
  readonly balanceBeforeBonus: bigint;
  readonly bonus: bigint;
  readonly finalBalance: bigint;
  readonly basisPoints: number;
};

export function quoteCommunityFinalBonus(
  balance: bigint,
  membership: CommunityMembershipSnapshot,
  config: GameConfig = GAME_CONFIG,
): CommunityBonusQuote {
  if (balance < 0n) throw new Error("Season balance cannot be negative");
  const eligible = membership.channel && membership.chat;
  const basisPoints = config.community.finalBalanceBonusBasisPoints;
  const bonus = eligible ? (balance * BigInt(basisPoints)) / BASIS_POINTS : 0n;
  return {
    eligible,
    balanceBeforeBonus: balance,
    bonus,
    finalBalance: balance + bonus,
    basisPoints,
  };
}

export function communityBonusIdempotencyKey(seasonId: string, userId: string): string {
  const normalizedSeasonId = seasonId.trim();
  const normalizedUserId = userId.trim();
  if (normalizedSeasonId === "" || normalizedUserId === "") {
    throw new Error("Community bonus identifiers cannot be empty");
  }
  return `dt:community-final-bonus:${normalizedSeasonId}:${normalizedUserId}`;
}
